export default "__VITE_ASSET__B181hOIa__"